import React from 'react'

import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Link,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CheckIcon, InfoIcon} from '../icons'
import InfoPopover from '../popovers/info-popover'
import {FormattedMessage, useIntl} from 'react-intl'

const BenefitCard = ({benefitLabel}) => {
    const styles = useMultiStyleConfig('BenefitCard')
    const intl = useIntl()

    const strongText = <FormattedMessage {...benefitLabel.strongText} />
    const normalText = <FormattedMessage {...benefitLabel.normalText} />
    const urlLink = benefitLabel.urlLink ? intl.formatMessage(benefitLabel.urlLink) : ''
    const infoPopoverTitle = intl.formatMessage(benefitLabel.infoPopover.title)
    const infoPopoverDescription = intl.formatMessage(benefitLabel.infoPopover.description)

    const label = (strongText || normalText) && (
        <Flex {...styles.textContainer}>
            {strongText && <Text {...styles.strongText}>{strongText}</Text>}
            {strongText && normalText && <Text {...styles.normalText}>&nbsp;</Text>}
            {normalText && <Text {...styles.normalText}>{normalText}</Text>}
        </Flex>
    )

    return (
        <Box {...styles.card}>
            <CheckIcon {...styles.icon} />
            {urlLink && urlLink !== benefitLabel.urlLink.id ? (
                <Link href={urlLink} {...styles.urlLink}>
                    {label}
                </Link>
            ) : (
                label
            )}
            {(infoPopoverTitle || infoPopoverDescription) && (
                <Box {...styles.infoPopBox}>
                    <InfoPopover
                        variant="left-center"
                        trigger={<InfoIcon {...styles.infoIcon} aria-label="More Info" />}
                        openTooltipOn="hover"
                        title={infoPopoverTitle}
                        description={infoPopoverDescription}
                    />
                </Box>
            )}
        </Box>
    )
}

BenefitCard.propTypes = {
    benefitLabel: PropTypes.shape({
        strongText: PropTypes.shape({
            id: PropTypes.string,
            defaultMessage: PropTypes.string,
        }),
        normalText: PropTypes.shape({
            id: PropTypes.string,
            defaultMessage: PropTypes.string,
        }),
        urlLink: PropTypes.shape({
            id: PropTypes.string,
            defaultMessage: PropTypes.string,
        }),
        infoPopover: PropTypes.shape({
            title: PropTypes.shape({
                id: PropTypes.string,
                defaultMessage: PropTypes.string,
            }),
            description: PropTypes.shape({
                id: PropTypes.string,
                defaultMessage: PropTypes.string,
            }),
        }),
    }),
}

export default BenefitCard
